/* Solo Dios · drop theme */
(function () {
  /* background plate */
  var v = document.getElementById('sd-bg'), plate = document.getElementById('sd-plate'), pp = document.getElementById('sd-pp');
  if (v && plate) {
    v.muted = true;
    v.addEventListener('playing', function () { plate.classList.add('has-video'); if (pp) pp.hidden = false; }, { once: true });
    v.play().catch(function () { plate.classList.add('has-video'); if (pp) { pp.hidden = false; pp.classList.add('paused'); } });
    if (pp) pp.addEventListener('click', function () {
      if (v.paused) { v.play(); pp.classList.remove('paused'); } else { v.pause(); pp.classList.add('paused'); }
    });
  }

  /* ticker */
  document.querySelectorAll('.ticker .track').forEach(function (t) {
    var items = (t.getAttribute('data-items') || '').split('|').map(function (s) { return s.trim(); }).filter(Boolean);
    if (!items.length) return;
    var html = ''; for (var r = 0; r < 4; r++) items.forEach(function (s) { html += '<span>' + s + '</span>'; });
    t.innerHTML = html;
  });

  /* mobile nav */
  document.querySelectorAll('.burger').forEach(function (b) {
    b.addEventListener('click', function () { var m = document.getElementById(b.getAttribute('data-menu')); if (m) m.classList.toggle('open'); });
  });

  /* home gate: countdown until go-live, then flip to the menu */
  var home = document.querySelector('.sd-gate-stone[data-go-live], .sd-home[data-go-live]');
  if (home) {
    var go = new Date(home.getAttribute('data-go-live')).getTime();
    var pad = function (n) { return String(n).padStart(2, '0'); };
    var cd = home.querySelector('#cd'), ch = home.querySelector('#ch'), cm = home.querySelector('#cm'), cs = home.querySelector('#cs');
    function tick() {
      var left = go - Date.now();
      if (isNaN(go) || left <= 0) {
        /* go-live: fetch the open site (query string skips any cached copy of the cover) */
        var u = location.pathname + '?live=' + Date.now();
        var again = /[?&]live=/.test(location.search) ? 15000 : 400;   /* still covered after a reload: retry every 15 s */
        setTimeout(function () { location.replace(u); }, again);
        return;
      }
      if (cd) cd.textContent = Math.floor(left / 864e5);
      if (ch) ch.textContent = pad(Math.floor(left / 36e5) % 24);
      if (cm) cm.textContent = pad(Math.floor(left / 6e4) % 60);
      if (cs) cs.textContent = pad(Math.floor(left / 1e3) % 60);
      setTimeout(tick, 1000);
    }
    tick();
    /* join-the-list form inside the gate (same as the password page) */
    var f = home.querySelector('form.join'), gate = home.querySelector('.gate'), sink = home.querySelector('iframe.sink');
    if (f && gate) {
      var sent = false, timer = null;
      function done() { if (!sent) return; clearTimeout(timer); gate.classList.add('sent'); }
      f.addEventListener('submit', function (e) {
        var email = f.elements['contact[email]'];
        if (!email.value || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email.value)) { e.preventDefault(); email.focus(); return; }
        sent = true; timer = setTimeout(done, 6000);
      });
      if (sink) sink.addEventListener('load', function () { if (sent) done(); });
    }
  }

  /* product: size buttons -> variant id */
  var pf = document.querySelector('form[data-sd-product]');
  if (pf) {
    var idInput = pf.querySelector('input[name="id"]'), btns = pf.querySelectorAll('.sizes button'), atc = pf.querySelector('.atc');
    var sel = function (b) {
      btns.forEach(function (o) { o.classList.remove('sel'); }); b.classList.add('sel');
      idInput.value = b.getAttribute('data-id');
      var avail = b.getAttribute('data-available') === 'true';
      if (atc && !atc.hasAttribute('data-locked')) { atc.disabled = !avail; atc.textContent = avail ? atc.getAttribute('data-label') : 'Sold out'; }
    };
    btns.forEach(function (b) { b.addEventListener('click', function (e) { e.preventDefault(); sel(b); }); });
    var first = pf.querySelector('.sizes button.sel') || pf.querySelector('.sizes button:not(.off)') || btns[0];
    if (first) sel(first);
  }
})();
